module.exports = __webpack_public_path__ + "img/product-order-3.4eb45e47.jpg";